import { createButton } from 'react-simple-wysiwyg';

import { Strikethrough01Icon } from '@/assets/icons/Strikethrough01Icon';

export default createButton('Strikethrough', <Strikethrough01Icon />, 'strikeThrough');
